import { post } from "../../request";

const sendConfirmationEmail = (): Promise<void> =>
  post("/api/users/resend_confirmation_email");

export default sendConfirmationEmail;
